import { render } from "./App.vue?vue&type=template&id=075593dc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=075593dc&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=075593dc&lang=scss"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075593dc"]])

export default __exports__